import React from "react";
import {TimeDelta, isEmpty} from "weed-js";
import {KPIPillColumnControls} from "./KPIPillColumnControls";

export const KPIPillColumn = ({
    title,
    activeWindow,
    column,
    defaultEnd,
    defaultMiddle,
    defaultStart,
    disposition="previous",  // "previous" or "current" or "both"
    setActiveWindow,
    setUserDefinedWindow,
    userDefinedWindow,
    tooltip,
    hideControls = false
}) => {
    const startDate = activeWindow?.[disposition]?.start || userDefinedWindow?.[disposition]?.start || defaultStart;
    const endDate = activeWindow?.[disposition]?.end || userDefinedWindow?.[disposition]?.end || defaultEnd;
    const dateSubtitle = startDate && endDate && "" +
            TimeDelta.formatShortDate(startDate?.toDate?.() ? startDate.toDate() : startDate) + " - " +
            TimeDelta.formatShortDate(endDate?.toDate?.() ? endDate.toDate() : endDate);


    return <div className={"kpi-grid-column-container"}>
        {!hideControls && <KPIPillColumnControls
            title={title}
            tooltip={tooltip}
            activeWindow={activeWindow}
            defaultEnd={defaultEnd}
            defaultMiddle={defaultMiddle}
            defaultStart={defaultStart}
            disposition={disposition}
            setActiveWindow={setActiveWindow}
            setUserDefinedWindow={setUserDefinedWindow}
            userDefinedWindow={userDefinedWindow}
        />}
        {hideControls && <h2 className={"kpi-pill-column-alternate-title"}>{title}&nbsp;{dateSubtitle ? `(${dateSubtitle})` : ""}</h2>}
        <div className={`kpi-grid kpi-grid-${disposition}-column`}>
            {isEmpty(column) ? "..." : column}
        </div>
    </div>
};

export default KPIPillColumn;